<template>
  <div class="f-col full prelude">
    <div class="f-col ctr context">
      <img class="brand" src="@/assets/brand-white.png" alt="SITE" />
      <Login v-if="context === 'login'" />
      <Forgotten v-else-if="context === 'forgotten'" />
      <Recovery :recovery="recovery" v-else-if="context === 'recovery'" />
    </div>
    <Background />
  </div>
</template>

<script>
import Login from "./Login.vue";
import Forgotten from "./Forgotten.vue";
import Recovery from "./Recovery.vue";
import Background from "./Background.vue";

export default {
  name: "Prelude",
  components: {
    Login,
    Forgotten,
    Recovery,
    Background,
  },
  computed: {
    recovery() {
      return this.$router.currentRoute.query.recovery;
    },
    context() {
      return this.$store.state.prelude.context;
    },
  },
  created() {
    this.$store.commit("TOGGLE_DISPLAY_LAYOUT", {
      menu: false,
      header: false,
      footer: false,
    });

    if (this.recovery) this.$store.commit("PRELUDE_UPDATE_CONTEXT", "recovery");
  },
};
</script>

<style scoped>
.prelude {
  position: relative;
}

.context {
  margin-bottom: 90px;
  z-index: 10;
  color: #fff;
}

.brand {
  width: 180px;
  margin: 5px;
}
</style>